import { useState } from 'react';
import { useCallback } from 'react';
import DataFlowService from '../../../services/DataFlow.service';

export function useOwner(dataFlowInfo) {
    const [ownersDepartment, setOwnersDepartment] = useState([]);
    const [owners, setOwners] = useState([]);

    const getOwnersDepartment = useCallback(async () => {
        if (dataFlowInfo?.departmentId)
            try {
                const { data } = await DataFlowService.getOwnersDepartment(
                    dataFlowInfo?.departmentId
                );
                if (data?.resultData) {
                    setOwnersDepartment(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
    }, [dataFlowInfo?.departmentId]);

    const getOwners = useCallback(async () => {
        if (dataFlowInfo?.businessProcessId)
            try {
                const { data } = await DataFlowService.getOwners(
                    dataFlowInfo?.businessProcessId
                );
                if (data?.resultData) {
                    const user = data?.resultData?.map((user) => user.userId);
                    setOwners(user);
                }
            } catch (error) {
                console.log(error);
            }
    }, [dataFlowInfo?.businessProcessId]);

    const updateOwner = useCallback(
        async (userId) => {
            if (userId) {
                try {
                    const payload = {
                        businessProcessId: dataFlowInfo?.businessProcessId,
                        userId,
                    };
                    const { data } = await DataFlowService.updateOwner(payload);
                    if (data?.resultData) {
                        getOwners();
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        },
        [dataFlowInfo?.businessProcessId, getOwners]
    );

    const deleteOwner = useCallback(
        async (userId) => {
            if (userId) {
                try {
                    const { data } = await DataFlowService.deleteOwner(
                        dataFlowInfo?.businessProcessId,
                        userId
                    );
                    if (data?.resultData) {
                        getOwners();
                    }
                } catch (error) {
                    console.log(error);
                }
            }
        },
        [dataFlowInfo?.businessProcessId, getOwners]
    );

    return {
        getOwnersDepartment,
        getOwners,
        owners,
        ownersDepartment,
        deleteOwner,
        updateOwner,
    };
}
